export enum PhoneNumberType {
	CHU_CO_SO_CONG_TRINH = 'CHU_CO_SO_CONG_TRINH',
	NGUOI_XAC_NHAN = 'NGUOI_XAC_NHAN',
	NGUOI_BACKUP = 'NGUOI_BACKUP',
}
